import styled from 'styled-components';
import { ApMenu, colors } from '@alixpartners/ui-components';

export const Wrapper = styled.nav`
  display: flex;
  border-bottom: 1px solid ${colors.grey3};
  background-color: white;
  padding: 0 32px;
  height: 48px;
`;

export const StyledMenu = styled(ApMenu)`
  overflow: hidden;
  display: flex;
`;
